(() => {
    "use strict"

    document.addEventListener('DOMContentLoaded', () => {
        if (document.querySelector('[data-fancybox]')) {
            Fancybox.bind('[data-fancybox]', {});
        }

        if (document.querySelector('#gallery-carousel')) {
            new Splide('#gallery-carousel', {
                type: 'loop',
                perPage: 3,
                perMove: 1,
                pagination: false,
                gap: 'clamp(1rem, 3.5vw, 2rem)',
                arrows: false,
                autoScroll: {
                    speed: .3,
                },
                breakpoints: {
                    1034: {
                        perPage: 2,
                    },
                    630: {
                        perPage: 1,
                    }
                }
            })
            .mount(window.splide.Extensions)
        }

        if (document.querySelector('#blog-carousel')) {
            new Splide('#blog-carousel', {
                perPage: 3,
                perMove: 1,
                arrows: false,
                pagination: false,
                gap: 'clamp(1rem, 3.5vw, 2rem)',
                breakpoints: {
                    1024: {
                        perPage: 2,
                        arrows: true,
                    },
                    525: {
                        perPage: 1,
                    }
                }
            })
            .mount()
        }

        if (document.querySelector('#partners-carousel')) {
            new Splide('#partners-carousel', {
                type: 'loop',
                perPage: 7,
                perMove: 1,
                pagination: false,
                arrows: false,
                gap: 'clamp(2rem, 3.5vw, 4rem)',
                disable: 'mobile',
                autoScroll: {
                    speed: .3,
                },
                breakpoints: {
                    1440: {
                        perPage: 6,
                    },
                    1024: {
                        perPage: 5,
                    },
                    600: {
                        perPage: 4,
                    },
                    420: {
                        perPage: 3,
                    }
                }
            })
            .mount(window.splide.Extensions)
        }

        if (document.querySelector('[data-aos]')) {
            AOS.init({
                offset: 30,
                delay: 300,
                duration: 1000,
                easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
                once: true,
                mirror: false,
                anchorPlacement: 'top-bottom',
            });
        }
    })

    if (document.getElementById('biscuit-notice')) {
        document.getElementById('biscuit-preferences').addEventListener('click', function () {
            const options = document.querySelector('.biscuit-acceptance__options')

            if (options.classList.contains('hidden')) {
                options.classList.remove('hidden')
                this.querySelector('.button__inner').textContent = 'Save Preferences'
                return
            }

            submitCookies(document.getElementById('biscuit-functional').checked, document.getElementById('biscuit-analytics').checked)
        })

        document.querySelectorAll('.biscuit-acceptance__option').forEach(option => option.addEventListener('click', function (evt) {
            if (evt.target.closest('label')) return

            option.querySelector('.biscuit-acceptance__option__description').classList.toggle('hidden')
        }))

        document.getElementById('biscuit-accept').addEventListener('click', function () {
            submitCookies(true, true)
        })

        document.getElementById('biscuit-deny').addEventListener('click', function () {
            submitCookies(false, false)
        })
    }

    if (document.querySelector('[data-tabs]')) {
        document.querySelectorAll('[data-tabs]').forEach(tabs => {
            const controls = tabs.querySelector('.tabs__controls')
            const buttons = tabs.querySelectorAll('.tabs__button')
            const panels = tabs.querySelectorAll('.tabs__panel')

            // Function to position the pseudo-element highlight
            const updateHighlight = activeBtn => {
                if (!activeBtn || !controls) return

                controls.style.setProperty('--highlight-left', `${activeBtn.offsetLeft}px`)
                controls.style.setProperty('--highlight-width', `${activeBtn.offsetWidth}px`)
            }

            // Position highlight on page load for the initial active tab
            const initialActive = tabs.querySelector('.tabs__button--active') || buttons[0]
            if (initialActive) {
                // Run on next tick so DOM offsets are fully rendered
                requestAnimationFrame(() => updateHighlight(initialActive))
            }

            buttons.forEach((button, index) => {
                button.addEventListener('click', () => {
                    buttons.forEach(btn => btn.classList.remove('tabs__button--active'))
                    panels.forEach(content => content.classList.remove('tabs__panel--active'))

                    button.classList.add('tabs__button--active')
                    if (panels[index]) {
                        panels[index].classList.add('tabs__panel--active')
                    }

                    // Move the highlight
                    updateHighlight(button)
                })
            })

            let resizeTimeout
            window.addEventListener('resize', () => {
                cancelAnimationFrame(resizeTimeout)
                resizeTimeout = requestAnimationFrame(() => {
                    const currentActive = tabs.querySelector('.tabs__button--active')
                    if (currentActive) updateHighlight(currentActive)
                })
            })
        })
    }

    // Header toggles: mobile nav menu and the "Contact Info" dropdown
    const headerToggles = [
        [document.getElementById('nav-menu-toggle'), document.querySelector('.nav__menu')],
        [document.querySelector('.header__button'), document.querySelector('.header__nav')],
    ].filter(([toggle, target]) => toggle && target)

    const setHeaderToggle = ([toggle, target], open) => {
        toggle.classList.toggle('active', open)
        target.classList.toggle('active', open)
        toggle.setAttribute('aria-expanded', open)
    }

    headerToggles.forEach(pair => {
        pair[0].setAttribute('aria-expanded', false)

        pair[0].addEventListener('click', () => {
            const open = !pair[0].classList.contains('active')

            // Only one open at a time
            headerToggles.forEach(other => setHeaderToggle(other, false))
            setHeaderToggle(pair, open)
        })
    })

    document.addEventListener('keydown', evt => {
        if (evt.key === 'Escape') headerToggles.forEach(pair => setHeaderToggle(pair, false))
    })

    window.addEventListener('click', evt => {

        if (evt.target.dataset.action) {
            evt.preventDefault();

            switch (evt.target.dataset.action) {
                case 'share':
                    openShareDialogue({
                        title: evt.target.dataset.shareTitle,
                        text: evt.target.dataset.shareText,
                        url: evt.target.dataset.shareUrl,
                    })
                    break
            }
        }

    })
})()

async function openShareDialogue(props) {
    if (navigator.share) {
        try {
            await navigator.share(props)
        }
        catch (err) {
            console.error('Error sharing: ', err)
        }
    }
    else {

    }
}

function submitCookies(functional, analytics) {
    document.getElementById('biscuit-notice').classList.add('hidden')
    let formData = new FormData()
    formData.append('functional', functional)
    formData.append('analytics', analytics)

    fetch('/scripts/cookie.php', {
        method: 'POST',
        body: formData
    })

    // Lets consent-gated features (e.g. the Mapbox map) load without a refresh
    document.dispatchEvent(new CustomEvent('cookieconsent', { detail: { functional, analytics } }))
}

// "Accept & Load" button on a video placeholder
function enableVideos() {
    fetch('/scripts/enable-functional-cookie.php', { method: 'POST' })
    document.getElementById('biscuit-notice')?.classList.add('hidden')
    document.dispatchEvent(new CustomEvent('cookieconsent', { detail: { functional: true } }))
}

// Swap video placeholders for their embeds once functional cookies are accepted
document.addEventListener('cookieconsent', (e) => {
    if (!e.detail.functional) return

    document.querySelectorAll('.video-consent').forEach((placeholder) => {
        placeholder.replaceWith(placeholder.querySelector('template').content)
    })
})
